var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "div",
                [
                  _c("micro-app", {
                    attrs: {
                      name: "child-operation-date-query-bookingverify",
                      url:
                        _vm.$store.getters.frontEndPluginUrl +
                        "/operationDateQuery",
                      "router-mode": "pure",
                      destroy: ""
                    },
                    on: { datachange: _vm.operationDateQueryDataChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "110",
                "is-append-query": true,
                reset: true,
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                )
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                defaultSearchItemsChange: function(value) {
                  _vm.defaultSearchItems = value
                }
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "1",
                        disabled: !_vm.selectedJob || _vm.total <= 0,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "2",
                        disabled: !_vm.btn.btnAdd,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onAdd()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "3",
                        disabled: !(_vm.btn.btnCopy && _vm.selectedJob),
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.copyJobHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                  ),
                  _vm.isHc
                    ? _c(
                        "el-dropdown",
                        {
                          staticStyle: { margin: "0 5px" },
                          attrs: {
                            no: "priceAuditHandle",
                            "split-button": "",
                            type: "primary",
                            disabled: !_vm.selectedJob || _vm.total <= 0
                          },
                          on: {
                            click: _vm.priceAuditHandle,
                            command: function(p) {
                              _vm.priceAuditCommand = p
                              _vm.priceAuditHandle()
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.priceAuditCommand) + " "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_preportAudit"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_preportAudit")
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_TrunkLineAudit"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_TrunkLineAudit")
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "CargoMsg.Cargo_TailEndAudit"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_TailEndAudit")
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmVerify_accept"
                          ]),
                          expression:
                            "$checkPermission(['button_fmVerify_accept'])"
                        }
                      ],
                      attrs: { no: "4", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.acceptHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmVerify_reject"
                          ]),
                          expression:
                            "$checkPermission(['button_fmVerify_reject'])"
                        }
                      ],
                      attrs: { no: "5", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.rejectHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_fmVerify_reviewThrough"
                            ]) && _vm.btn.pretrialReviewConfig,
                          expression:
                            "$checkPermission(['button_fmVerify_reviewThrough']) && btn.pretrialReviewConfig"
                        }
                      ],
                      attrs: { no: "6", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.btVerifyReviewThroughHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.VerifyReviewThrough")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_fmVerify_reviewRefusal"
                            ]) && _vm.btn.pretrialReviewConfig,
                          expression:
                            "$checkPermission(['button_fmVerify_reviewRefusal']) && btn.pretrialReviewConfig"
                        }
                      ],
                      attrs: {
                        no: "7",
                        disabled: !(
                          _vm.btn.btVerifyReviewRefusal &&
                          _vm.btn.pretrialReviewRefusalRole
                        ),
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.btVerifyReviewRefusalHandler(0)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.VerifyReviewRefusal")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmVerify_cloneCabin"
                          ]),
                          expression:
                            "$checkPermission(['button_fmVerify_cloneCabin'])"
                        }
                      ],
                      attrs: {
                        no: "8",
                        disabled: !(_vm.btn.cloneCabin && _vm.btn.acceptRole),
                        type: "primary"
                      },
                      on: { click: _vm.cloneCabinHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CloneCabinBerth")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmVerify_cabinBackFill"
                          ]),
                          expression:
                            "$checkPermission(['button_fmVerify_cabinBackFill'])"
                        }
                      ],
                      attrs: {
                        no: "9",
                        disabled: !(
                          _vm.btn.cabinBackFill && _vm.btn.rejectRole
                        ),
                        type: "primary"
                      },
                      on: { click: _vm.cabinBackFillHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BackFillCabinBerth")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission(["button_fmVerify_edit"]),
                          expression:
                            "$checkPermission(['button_fmVerify_edit'])"
                        }
                      ],
                      attrs: {
                        no: "10",
                        disabled: !_vm.btn.acceptRole,
                        type: "success"
                      },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmVerify_generateBusiness"
                          ]),
                          expression:
                            "$checkPermission(['button_fmVerify_generateBusiness'])"
                        }
                      ],
                      attrs: {
                        no: "11",
                        disabled: !(
                          _vm.btn.generateBusiness && _vm.btn.rejectRole
                        ),
                        type: "primary"
                      },
                      on: { click: _vm.generateBusinessHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.GenerateBusiness")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmVerify_returnCabin"
                          ]),
                          expression:
                            "$checkPermission(['button_fmVerify_returnCabin'])"
                        }
                      ],
                      attrs: {
                        no: "12",
                        disabled: !(_vm.btn.returnCabin && _vm.btn.rejectRole),
                        type: "primary"
                      },
                      on: { click: _vm.returnCabinHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ReturnCabin")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_fmVerify_batchVessel"
                          ]),
                          expression:
                            "$checkPermission(['button_fmVerify_batchVessel'])"
                        }
                      ],
                      attrs: { no: "13", type: "primary" },
                      on: { click: _vm.batchVesselHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BatchVessel")))]
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "130100",
                  "grid-options": _vm.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-params": _vm.gridParams,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "show-row-groups": _vm.dataListDragGroup,
                  "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: _vm.onGridReady
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "110001",
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "selected-row-count": _vm.selectedRowCount
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.opVerifyFrameDialog.visible
        ? _c("op-verify-frame-dialog", {
            attrs: {
              visible: _vm.opVerifyFrameDialog.visible,
              "job-model": _vm.opVerifyFrameDialog.job || {},
              "batch-pass-audit": _vm.opVerifyFrameDialog.batchPassAudit,
              "submit-call-back": _vm.opVerifyFrameDialog.submitCallBack,
              "job-list": _vm.opVerifyFrameDialog.jobList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.opVerifyFrameDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("op-verify-frame-reject", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "job-list": _vm.rejectWindow.jobList,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.confirmDialogWindow.visible
        ? _c("confirm-dialog-window", {
            attrs: {
              visible: _vm.confirmDialogWindow.visible,
              "message-title": _vm.confirmDialogWindow.messageTitle,
              content: _vm.confirmDialogWindow.content,
              "show-confirm-btn": _vm.confirmDialogWindow.showConfirmBtn,
              "confirm-call-back": _vm.confirmDialogWindow.confirmCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.confirmDialogWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cabinBackFillWindow.visible
        ? _c("cabin-back-fill-window", {
            attrs: {
              visible: _vm.cabinBackFillWindow.visible,
              "job-model": _vm.cabinBackFillWindow.job || {},
              context: _vm.context
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cabinBackFillWindow, "visible", $event)
              },
              reloadFunc: _vm.reloadFunc
            }
          })
        : _vm._e(),
      _c("cabin-duplicate-dialog", {
        attrs: {
          visible: _vm.cabinDuplicateForm.dialogVisible,
          job: _vm.selectedJob,
          "reload-func": null
        },
        on: {
          submit: _vm.cabinDuplicateSubmit,
          close: function($event) {
            _vm.cabinDuplicateForm.dialogVisible = false
          }
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("edit-dialog", {
        attrs: {
          visible: _vm.editDialog.visible,
          "job-model": _vm.editDialog.job,
          context: _vm.context
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          reloadFunc: _vm.reloadFunc
        }
      }),
      _vm.transshipDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.transshipDialog.visible,
                title: _vm.$t("SeaExport.BatchVessel"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.transshipDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-advance-select", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.transshipDialog.isDBFlag,
                                expression: "!transshipDialog.isDBFlag"
                              }
                            ],
                            staticStyle: { width: "250px" },
                            attrs: {
                              disabled: _vm.clearCheckBox.vessel,
                              no: "14",
                              filterable: "",
                              "options-width": "195px;",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Vessel,
                              "default-value": _vm.transshipDialog.txtVessel,
                              "callback-params": { key: "txtVessel" }
                            },
                            on: { parentCallBack: _vm.onVesselSelectionChange }
                          }),
                          _c("el-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.transshipDialog.isDBFlag,
                                expression: "transshipDialog.isDBFlag"
                              }
                            ],
                            staticStyle: { width: "250px" },
                            attrs: {
                              disabled: _vm.clearCheckBox.vessel,
                              no: "15"
                            },
                            model: {
                              value: _vm.transshipDialog.txtVessel_1,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.transshipDialog,
                                  "txtVessel_1",
                                  $$v
                                )
                              },
                              expression: "transshipDialog.txtVessel_1"
                            }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                change: function($event) {
                                  return _vm.clearCheckBoxChange("vessel")
                                }
                              },
                              model: {
                                value: _vm.clearCheckBox.vessel,
                                callback: function($$v) {
                                  _vm.$set(_vm.clearCheckBox, "vessel", $$v)
                                },
                                expression: "clearCheckBox.vessel"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ClearData")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-select",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.transshipDialog._isVoyages,
                                  expression: "!transshipDialog._isVoyages"
                                }
                              ],
                              staticStyle: { width: "250px" },
                              attrs: { disabled: _vm.clearCheckBox.voyage },
                              model: {
                                value: _vm.transshipDialog.txtVoyage,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.transshipDialog,
                                    "txtVoyage",
                                    $$v
                                  )
                                },
                                expression: "transshipDialog.txtVoyage"
                              }
                            },
                            _vm._l(_vm.transshipDialog.voyages, function(item) {
                              return _c("el-option", {
                                key: item.voyageId,
                                attrs: {
                                  label: item.voyageNo,
                                  value: item.voyageNo
                                }
                              })
                            }),
                            1
                          ),
                          _c("el-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.transshipDialog._isVoyages,
                                expression: "transshipDialog._isVoyages"
                              }
                            ],
                            staticStyle: { width: "250px" },
                            attrs: {
                              no: "16",
                              disabled: _vm.clearCheckBox.vessel,
                              value:
                                _vm.transshipDialog._fmVerify &&
                                _vm.transshipDialog.txtVoyage_1.indexOf("V.") <
                                  0
                                  ? "V." + _vm.transshipDialog.txtVoyage_1
                                  : _vm.transshipDialog.txtVoyage_1
                            },
                            on: {
                              input: function(val) {
                                _vm.transshipDialog.txtVoyage_1 = val
                              }
                            }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                change: function($event) {
                                  return _vm.clearCheckBoxChange("voyage")
                                }
                              },
                              model: {
                                value: _vm.clearCheckBox.voyage,
                                callback: function($$v) {
                                  _vm.$set(_vm.clearCheckBox, "voyage", $$v)
                                },
                                expression: "clearCheckBox.voyage"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ClearData")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c("el-form-item", { attrs: { label: "IMO" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "250px" },
                          attrs: { disabled: _vm.clearCheckBox.imo, no: "17" },
                          model: {
                            value: _vm.transshipDialog.txtVesselIMO,
                            callback: function($$v) {
                              _vm.$set(_vm.transshipDialog, "txtVesselIMO", $$v)
                            },
                            expression: "transshipDialog.txtVesselIMO"
                          }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "10px" },
                            on: {
                              change: function($event) {
                                return _vm.clearCheckBoxChange("imo")
                              }
                            },
                            model: {
                              value: _vm.clearCheckBox.imo,
                              callback: function($$v) {
                                _vm.$set(_vm.clearCheckBox, "imo", $$v)
                              },
                              expression: "clearCheckBox.imo"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ClearData")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ShippingCompany") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              no: "18",
                              filterable: "",
                              disabled: _vm.clearCheckBox.carrierId,
                              "options-width": "200px;",
                              "method-params": { seaCmp: true },
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "default-value":
                                _vm.transshipDialog.txtCarrierId || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.transshipDialog.txtCarrierId =
                                  p.cmpIdx)
                              }
                            }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                change: function($event) {
                                  return _vm.clearCheckBoxChange("carrierId")
                                }
                              },
                              model: {
                                value: _vm.clearCheckBox.carrierId,
                                callback: function($$v) {
                                  _vm.$set(_vm.clearCheckBox, "carrierId", $$v)
                                },
                                expression: "clearCheckBox.carrierId"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ClearData")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DateOfDeparture") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "212px" },
                        attrs: {
                          no: "19",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.transshipDialog.dfETD,
                          callback: function($$v) {
                            _vm.$set(_vm.transshipDialog, "dfETD", $$v)
                          },
                          expression: "transshipDialog.dfETD"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              no: "20",
                              filterable: "",
                              disabled: _vm.clearCheckBox.bookingAgent,
                              "options-width": "200px;",
                              "method-params": { bookingAgent: true },
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "default-value":
                                _vm.transshipDialog.txtBookingAgent || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.transshipDialog.txtBookingAgent =
                                  p.cmpIdx)
                              }
                            }
                          }),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                change: function($event) {
                                  return _vm.clearCheckBoxChange("bookingAgent")
                                }
                              },
                              model: {
                                value: _vm.clearCheckBox.bookingAgent,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.clearCheckBox,
                                    "bookingAgent",
                                    $$v
                                  )
                                },
                                expression: "clearCheckBox.bookingAgent"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ClearData")))]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "21", type: "primary" },
                      on: { click: _vm.transShipClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "22" },
                      on: {
                        click: function($event) {
                          _vm.transshipDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              "sea-job": _vm.cooperationVerifyDialog.job,
              config: _vm.cooperationVerifyDialog.config,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              "allow-partial-check-pass":
                _vm.batchCheckingWindow.allowPartialCheckPass,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2,
              "new-job": _vm.batchCheckingWindow.newJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }